import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import { IHistoryState, HistoryState } from './history-states.store';
import { HistoryServices } from '../../services';
import mutations from './history-mutations.store'
import actions from './history-actions.store'
import getters from './history-getters.store'
export class HistoryModule<RootState> implements Module<IHistoryState, RootState>{
  namespaced: boolean;
  state: IHistoryState;
  getters: GetterTree<IHistoryState, RootState>;
  actions: ActionTree<IHistoryState, RootState>;
  mutations: MutationTree<IHistoryState>;
  /**
   *
   */
  constructor() {
    this.namespaced = true;
    this.state = new HistoryState({ service: new HistoryServices })
    this.mutations = mutations;
    this.actions = actions;
    this.getters = getters;
  }
}